<template lang="pug">
  section
    v-alert(:value='invalidEmails')
      div(class='subheading') Внимание! Некотрые адреса электронной введены ошибочно
      v-chip(v-for='email in invalidEmails' :key='email' color='white')
        div {{ email }}
    v-expansion-panel(inset)
      v-expansion-panel-content(
        v-for='notification in notifications'
        :key='notification.id'
      )
        template(v-slot:header)
          div {{ notification.name }}
        v-card(flat)
          v-card-text
            v-combobox(
              multiple
              label='Список адресов электронной почты'
              append-icon
              chips
              deletable-chips
              class='tag-input'
              v-model='select[notification.id]'
            )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='save'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import http from '@/http'
import { isString } from 'lodash'
export default {
  props: ['complexId', 'emails'],

  data: () => ({
    select: {},
    isLoading: false,
    notifications: [],
    invalidEmails: null
  }),

  created() {
    if (this.emails) {
      this.createNotifications()
    }
  },

  methods: {
    async save() {
      this.isLoading = true
      try {
        await http.post(`/complexes/${this.complexId}/feedbacksettings`, {
          emails: this.select
        })
      } catch (e) {
        this.$root.showSnack('Ошибка сохранения списка уведомлений', e)
      } finally {
        this.isLoading = false
      }
    },

    async createNotifications() {
      try {
        const response = await http.get('/data/feedback-types')
        this.notifications = response.data
        this.select = this.notifications.reduce((acc, cur) => {
          acc[cur.id] || (acc[cur.id] = [])
          acc[cur.id] = acc[cur.id].concat(this.emails[cur.id] || [])
          return acc
        }, {})
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки списка уведомлений', e)
      }
    }
  },

  watch: {
    select: {
      deep: true,
      handler(notifications) {
        const invalid = v => isString(this.$rules.email(v.trim()))
        const errors = Object.keys(notifications)
          .map(notification => notifications[notification].filter(invalid))
          .flat()
        this.invalidEmails = errors.length ? errors : null
      }
    },

    emails() {
      this.createNotifications()
    }
  }
}
</script>

<style>
.tag-input span.chip {
  background-color: #27ae60;
  color: #fff;
  font-size: 1em;
}

.tag-input span.v-chip {
  background-color: #27ae60;
  color: #fff;
  font-size: 1em;
  padding-left: 7px;
}

.tag-input span.v-chip::before {
  content: 'label';
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
}
</style>
